<template>
  <div>
    <Breadcrumbs main="employees" title="manage" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5>Employees List</h5>
              <span
                >Here you can search for an employee and select (one). After selecting, it is possible to <strong>edit</strong> a given employee.</span
              ><span
                >Please, edit the users carefully, it is not possible to restore the previous state.</span
              >
            </div>

            <div class="card-body">
              <b-row>
                <b-col md="6" class="delete-datatable">
                  <b-button
                    variant="primary"
                    @click="deleteBatchRow"
                    class="mb-3"
                    >Edit employee</b-button
                  >
                  <b-input-group class="datatable-btn">
                    <b-form-input
                      v-model="filter"
                      placeholder="Type to Search"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''"
                        >Clear</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                    label-cols="2"
                    label="Per page"
                    class="datatable-select"
                  >
                    <b-form-select
                      v-model="perPage"
                      :options="pageOptions"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <div class="table-responsive datatable-vue" v-if="getUsers">
                <b-table
                  selectable
                  :select-mode="selectMode"
                  show-empty
                  stacked="md"
                  selectedVariant="success"
                  :items="getUsers"
                  :fields="tablefields"
                  :filter="filter"
                  :current-page="currentPage"
                  :per-page="perPage"
                  @filtered="onFiltered"
                  @row-selected="rowSelected"
                  v-if="getUsers"
                >
                  <template slot="action" slot-scope="row">
                    <b-button variant="danger" @click="deleteRow(row.index)"
                      >Delete</b-button
                    >
                  </template>
                  <template slot="isDeleted" slot-scope="row">
                    {{ row.item ? "Yes :)" : "No :(" }}
                  </template>
                  <template #cell(active)="data"
                    >{{ data.item.active ? "Active" : "Not active" }}
                  </template>
                </b-table>
              </div>

              <b-col md="6" class="my-1">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="getRowLength"
                  :per-page="perPage"
                  class="my-0"
                ></b-pagination>
              </b-col>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      modes: ["single"],

      tablefields: [
        { key: "firstName", label: "First name", sortable: true },
        { key: "lastName", label: "Last name", sortable: true },
        { key: "mail", label: "E-mail", sortable: true },
        { key: "drivingSys", label: "Driving system", sortable: true },
        { key: "phoneNum", label: "Phone number", sortable: true },
        { key: "workStart", label: "Started work", sortable: true },
        { key: "active", label: "Status", sortable: true },
      ],
      filter: null,
      isLoading: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 50],

      selectMode: "single",
      selected: null,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.tablefields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    getUsers() {
      return !this.isLoading && this.$store.getters["users/fetchUsers"];
    },
    // set initial table rows
    getUsersLength(){
      return !this.isLoading && this.$store.state.users.users.length;
    },
    getRowLength(){
      if(this.filter){
        return this.totalRows
      } else {
        return this.getUsersLength
      }
    }
  },

  created(){
      this.fetchData();
  },
 
  methods: {
    onFiltered(filteredItems) {
      console.log(filteredItems.length)
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    rowSelected(item) {
      this.selected = item;
    },
    deleteRow(index) {
      this.getUsers.data.splice(index, 1);
    },
    async fetchData() {
      this.isLoading = true;
      await this.$store.dispatch("users/fetchUsers");
      this.isLoading = false;
    },
    deleteBatchRow(event) {
      // edit employee
      // for (var i = 0; i < this.selected.length; i++) {
      //   if (this.getUsers.data[i].id == this.selected[i].id) {
      //     this.getUsers.data.splice(this.getUsers.data[i], 1);
      //   }
      // }
      console.log(this.selected[0].id);
      this.$router.push(`/employees/${this.selected[0].id}`)
    },
  },
};
</script>
